// removed by extract-text-webpack-plugin
module.exports = {"activityIntroduceContent":"activityIntroduceContent__3L2QX","activityIntroduce":"activityIntroduce__1XVvn"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/ActivityIntroduce/index.css
// module id = 1478
// module chunks = 0